import { render, staticRenderFns } from "./FeatureCardMasterplanRp.vue?vue&type=template&id=5877c23a&"
import script from "./FeatureCardMasterplanRp.vue?vue&type=script&lang=js&"
export * from "./FeatureCardMasterplanRp.vue?vue&type=script&lang=js&"
import style0 from "./FeatureCardMasterplanRp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VHover,VIcon,VRow})
